import { useLogger } from '@lumahealthhq/ui-utils';
import useModelContext from './useModelContext';
export default function useSetCurrentAuth() {
  const logger = useLogger();
  const setCurrentAuth = useModelContext(s => s.setCurrentAuth);
  if (!setCurrentAuth) {
    logger.error('"setCurrentAuth" is missing');
  }
  return setCurrentAuth || (() => {});
}